import { useEffect } from 'react'

type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void
  queue: unknown[][]
  push: Fbq
  loaded: boolean
  version: string
}

declare global {
  interface Window {
    fbq?: Fbq
    _fbq?: Fbq
    __metaPixelInitialized?: Record<string, boolean>
  }
}

/**
 * Snippet standard Meta Pixel (fbevents.js en_US): init + un solo PageView
 * per caricamento reale della pagina. Protetto da doppi caricamenti e
 * doppie inizializzazioni. Nessun evento Purchase viene inviato qui:
 * l’acquisto va registrato solo alla conferma reale del pagamento.
 */
export function useMetaPixel(pixelId: string) {
  useEffect(() => {
    if (!pixelId) return

    if (!window.fbq) {
      const fbq = function (...args: unknown[]) {
        if (fbq.callMethod) fbq.callMethod(...args)
        else fbq.queue.push(args)
      } as Fbq
      if (!window._fbq) window._fbq = fbq
      fbq.push = fbq
      fbq.loaded = true
      fbq.version = '2.0'
      fbq.queue = []
      window.fbq = fbq

      const script = document.createElement('script')
      script.async = true
      script.src = 'https://connect.facebook.net/en_US/fbevents.js'
      const first = document.getElementsByTagName('script')[0]
      if (first?.parentNode) first.parentNode.insertBefore(script, first)
      else document.head.appendChild(script)
    }

    window.__metaPixelInitialized = window.__metaPixelInitialized ?? {}
    if (window.__metaPixelInitialized[pixelId]) return
    window.__metaPixelInitialized[pixelId] = true

    window.fbq?.('init', pixelId)
    window.fbq?.('track', 'PageView')
  }, [pixelId])
}
